import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _InputMessage from '../InputMessage/index.js';
import { StyledOptionalTag } from '../Label/index.js';

var _excluded = ["children", "error", "label", "legendStyles", "hideLabel", "theme", "optional", "language", "field"];
var _templateObject, _templateObject2;
var StyledFieldset = styled('fieldset')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n\n  & legend {\n    text-align: left;\n    margin-bottom: 1rem;\n    font-weight: bold;\n  }\n"])));
var StyledSub = styled('sub')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  text-align: left;\n  margin-top: 1rem;\n  color: ", ";\n\n  & span {\n    margin-left: 0.25rem;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.errorDark;
});
var InputGroup = function InputGroup(_ref2) {
  var children = _ref2.children,
    error = _ref2.error,
    label = _ref2.label,
    legendStyles = _ref2.legendStyles,
    hideLabel = _ref2.hideLabel,
    _ref2$theme = _ref2.theme,
    _ref2$optional = _ref2.optional,
    optional = _ref2$optional === void 0 ? false : _ref2$optional,
    _ref2$language = _ref2.language,
    language = _ref2$language === void 0 ? 'en' : _ref2$language,
    field = _ref2.field,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var newLegendStyles = _objectSpread2({
    display: hideLabel ? 'none' : 'block'
  }, legendStyles);
  return /*#__PURE__*/React.createElement(StyledFieldset, rest, /*#__PURE__*/React.createElement("legend", {
    style: newLegendStyles,
    "aria-label": label,
    "aria-describedby": error ? 'error' : undefined
  }, label, optional && /*#__PURE__*/React.createElement(StyledOptionalTag, null, "(", language === 'en' ? 'optional' : 'opcional', ")")), children, /*#__PURE__*/React.createElement(_InputMessage, {
    id: "error-".concat(field),
    role: 'alert',
    "aria-live": 'assertive',
    error: true,
    hidden: !error
  }, error ? error : ''));
};
var _InputGroup = withDefaultTheme(/*#__PURE__*/memo(InputGroup));

export default _InputGroup;
